/** «Pacchetto X — seduta 2 di 5 — scade il 14/10/2026»: come si presenta un
    pacchetto aperto in «Continua pacchetto» (Alex, 28/09/2026). La data e'
    quella del server (aaaa-mm-gg), girata senza passare dal fuso. */
export const etichettaPacchetto = (p) => {
    const [a, m, g] = String(p.data_scadenza || '').slice(0, 10).split('-');
    return `${p.descrizione} — seduta ${p.prossima} di ${p.numero_sedute}`
        + (a && m && g ? ` — scade il ${g}/${m}/${a}` : ' — senza scadenza');
};
